import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

const Log = new Logger("StoreLocator/Marker");


class Marker {

  /**
   * Constructor method
   *
   * @param data: object representing `store` information
   * @param map: optional map object which marker will be attached to
   */
  constructor(data) {
    this.data = data;
    this.__map__ = null;
    return this;
  }


  /**
   * Sets the MapEngine
   */
  set map(map){
    this.__map__ = map;
    return this;
  }

  /**
   * Get the MapEngine
   */
  get map() {
    return this.__map__;
  }


  /**
   * Returns all store data
   */
  get storeData() {
    return this.data;
  };


  /**
   * Returns property
   *
   * @param key: string representing the property
   */
  getKey() {
    return this.data[ this.map.options.markerkey ];
  }

  /**
   * Returns property
   *
   * @param key: string representing the property
   */
  get(key) {
    return this.data[ key ];
  }

  /**
   * Returns the coordinates of the marker pin
   */
  get coordinates() {
    return {lat: this.data.coordinates[0], lng: this.data.coordinates[1]};
  }

  /**
   * Method used to set the image of the marker
   *
   * @param img: literal object `{Url: "url", Size: {height: 50, width: 50}}`
   */
  set image(image) {
    Log.error("'setImage' method is not implemented");
    return this;
  }

  /**
   * Returns current marker's image
   *
   * @return literal object representing current marker's image
   */
  get image() {
    Log.error("'getImage' method is not implemented");
  }

  /**
   * Hides the pin on the map
   */
  hide() {
    Log.error("no `hide` method for marker has been implemented");
  }

  /**
   * Shows the pin on the map
   */
  show() {
    Log.error("no `show` method for marker has been implemented");
  }

  /**
   * Brings/Unbrings the pin on top
   *
   * @param hightlight: boolean determinates if bring pin on top or not
   */
  highlight(highlight) {
    Log.error("'highlight' method is not implemented");
    return this;
  }


  /**
   * Returns the cluster that contains the pin
   */
  get cluster() {
    Log.error("no `cluster` implemented");
    return null;
  }

  /**
   * Brings/Unbrings the cluster on top
   */
  highlightCluster() {
    Log.error("cannot hightlight `cluster`");
    return null;
  }


  /**
   * Add a event listener function
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  on(ev, fn) {
    Log.error("'on' method is not implemented");
    return this;
  }

  /**
   * Remove a event listener function
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  off(ev, fn){
    Log.error("'off' method is not implemented");
    return this;
  }

  /**
   * Fires a event
   *
   * @param ev: string representing the event name
   * @param fn: the handler function
   */
  trigger(ev) {
    Log.error("'trigger' method is not implemented");
    return this;
  }

  /**
   * Clone marker in order to attach it to another map
   */
  clone() {
    Log.error("'clone' method is not implemented");
  }

  /**
   * Show `InfoWindow` for marker
   *
   * @param html: the HTML rendered into InfoWindow
   */
  showTooltip(html) {
    Log.error("'showTooltip' method is not implemented");
  }

  /**
   * Hides and removes the tooltip
   */
  removeTooltip() {
    Log.error("'removeTooltip' method is not implemented");
  }


  /**
   * Set text to Marker
   * @param text: the String used as label
   */
  set label(text) {
    Log.error("'setLabel' method is not implemented");
  }


  /**
   * Returns the label of the Marker
   */
  get label() {
    Log.error("'getLabel' method is not implemented");
  }


  /**
   * Sets the tooltip title of the marker
   */
  set title(text) {
    Log.error("'getTitle' method is not implemented");
    return this;
  }


  /**
   * Returns the title of the marker
   */
  get title() {
    Log.error("'setTitle' method is not implemented");
  }


}


export default Marker
